export type ParsedApproval =
  | { kind: 'request'; reqId: number; method: string; summary: string }
  | { kind: 'responded'; reqId: number; decision: string; summary: string }
  | null

const APPROVAL_RE = /^__(APPROVAL_REQUEST|APPROVAL_RESPONDED)__(\d+)__(.+?)__\n([\s\S]*)$/

export function parseApproval(body: string | null | undefined): ParsedApproval {
  if (!body) return null

  const match = body.match(APPROVAL_RE)
  if (!match) return null

  const reqId = Number.parseInt(match[2], 10)
  const value = match[3]
  const summary = match[4].trim()

  if (match[1] === 'APPROVAL_REQUEST') {
    return {
      kind: 'request',
      reqId,
      method: value,
      summary,
    }
  }

  return {
    kind: 'responded',
    reqId,
    decision: value,
    summary,
  }
}
